import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]

  connect() {
    this.originalValue = this.inputTarget.value
  }

  edit() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  handleBlur() {
    if (this.inputTarget.value.trim() === this.originalValue.trim()) {
      this.cancel()
      return
    }

    this.submit()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }

    if (event.key === "Enter") {
      event.preventDefault()
      this.submit()
    }
  }

  cancel() {
    this.inputTarget.value = this.originalValue
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  submit() {
    const nextValue = this.inputTarget.value.trim()

    if (!nextValue.length) {
      this.cancel()
      return
    }

    this.inputTarget.value = nextValue
    this.formTarget.requestSubmit()
  }
}
